import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import focalPointApiClient from 'Services/Apis/FocalPoint/conciergeApiClient';

export const getParticipantIsFocalPointThunk = createAsyncThunk(
    `GetParticipantIsFocalPointSlicer/getParticipantIsFocalPointThunk`,
    async (_, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
        };

        const { data } = await focalPointApiClient.get(
            `/Participant/is-focal-point`,
            {
                headers,
            });
        return data;
    }
);

const initialState = {
    dataGetParticipantIsFocalPoint: false,
    finishedParticipantIsFocalPoint: false,
    loadingGetParticipantIsFocalPoint: false,
    errorGetParticipantIsFocalPoint: false,
};

const GetParticipantIsFocalPointSlicer = createSlice({
    name: 'GetParticipantIsFocalPoint',
    initialState,
    reducers: {
        resetDataGetParticipantIsFocalPoint: (state) => {
            state.dataGetParticipantIsFocalPoint = false;
            state.loadingGetParticipantIsFocalPoint = false;
            state.errorGetParticipantIsFocalPoint = false;
            state.finishedParticipantIsFocalPoint = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getParticipantIsFocalPointThunk.pending, (state) => {
            state.dataGetParticipantIsFocalPoint = false;
            state.loadingGetParticipantIsFocalPoint = true;
            state.errorGetParticipantIsFocalPoint = false;
            state.finishedParticipantIsFocalPoint = false;
        });
        builder.addCase(getParticipantIsFocalPointThunk.fulfilled, (state, action) => {
            state.dataGetParticipantIsFocalPoint = action.payload;
            state.loadingGetParticipantIsFocalPoint = false;
            state.errorGetParticipantIsFocalPoint = false;
            state.finishedParticipantIsFocalPoint = true;
        });
        builder.addCase(getParticipantIsFocalPointThunk.rejected, (state) => {
            state.dataGetParticipantIsFocalPoint = false;
            state.loadingGetParticipantIsFocalPoint = false;
            state.errorGetParticipantIsFocalPoint = true;
            state.finishedParticipantIsFocalPoint = true;
        });
    },
});

export const { resetDataGetParticipantIsFocalPoint } = GetParticipantIsFocalPointSlicer.actions;
export default GetParticipantIsFocalPointSlicer.reducer;